import React, { useState } from 'react'
import EditIcon from '@material-ui/icons/Edit';
import WmModals from '../../modals/Wm.Modals';
import Wmbutton from '../../ui-components/wm-button/Wm.button';
import { connect } from "react-redux";
import Required from '../required/Required';
import { editSkills,skillsDelete } from "../../services/actions/actions"
import NumberRating from '../Rating/NumberRating';
function SkillPills({ resume, data, id ,handleEditSkills,handleDeleteSkills}) {
    const circle = []
    for (let i = 0; i < 5; i++) {
        let klass;
        if (data.skillRange > i && data.skillRange != null) {
            klass += " is-selected";
        }
        circle.push(<div key={i} className={`${klass} w-7 h-7 rounded-full border shadow-md`}></div>)
    }
    const [skillId, setSkillId] = useState('')
    const [skillData, setSkillData] = useState({ title: '', rate: '' })
    const handleTitle = (value) => {
        setSkillData((skillData) => {
            skillData.title = value
            return { ...skillData }
        })
    }
    const [openEditModal, setOpenEditModal] = useState(false)
    const handleEditSkill = (id) => {
        setSkillId(id)
        setOpenEditModal(true)
        setSkillData({ title: resume.skills[id].title, rate: resume.skills[id].skillRange })
    }
    return (
        <>
            <div className="bg-gray-200 select-none rounded-xl flex px-4 py-3 items-center shadow-md mr-3 mb-4">
                <div className='pr-3 border-r border-gray-300 border-solid'>
                    <span className='manpro font-medium text-base block mb-2'>{data.title}</span>
                    <div className='space-x-4 flex'>
                        {circle}
                    </div>
                </div>
                <div className="cursor-pointer pl-3">
                    <EditIcon onClick={() => handleEditSkill(id)} />
                </div>
            </div>
            <WmModals show={openEditModal} onHide={() => setOpenEditModal(false)} size="md" className="">
                <div className="modal--head border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="modal-title manpro font-bold text-2xl">Skills</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--body border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="wm_form_group flex flex-col">
                                    <label className="wm_form_label"> Title <Required /></label>
                                    <input type="text" name="institute" required className="wm_form_input border-bottom border-gray-300" value={skillData.title} onChange={(e) => handleTitle(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className='border rounded mt-3'>
                                    <div className='text-center manpro font-semibold text-xl py-2'>
                                        Range select
                                    </div>
                                    <div className='m-2 py-2 bg-gray-100 rounded-3xl'>
                                        <NumberRating range={5} rangeValue={skillData.rate - 1} onSelectRange={(range) => setSkillData(() => { skillData.rate = range; return { ...skillData } })} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--foot py-3">
                    <div className="container-fluid">
                        <div className="row justify-end px-3">
                            <div className="space-x-3">
                                <Wmbutton className="px-4 rounded" label="Edit" type="button" color="primary" onClick={() => {handleEditSkills(skillId,skillData);setOpenEditModal(false)}} />
                                <Wmbutton className="px-4 rounded" label="Delete" bordered type="button" color="primary-border" onClick={() => {handleDeleteSkills(skillId);setOpenEditModal(false)}} />
                                <Wmbutton className="px-4 rounded" label="Cancel" bordered type="button" color="primary-border" onClick={() => setOpenEditModal(false)} />
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    )
}


const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleEditSkills: (id, value) => {
            dispatch(editSkills(id,value))
        },
        handleDeleteSkills: (id) => {
            dispatch(skillsDelete(id))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(SkillPills)
